import { TableCell, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useApiMutation } from "src/hooks/useApiMutation";
import EditMoneyReceipt from "./EditMoneyReceipt";
import type { IMoneyReceipt } from "./type/moneyReceiptType";

type IProps = {
	account: IMoneyReceipt;
	serial: number;
	paginationSkip: number;
};

const MoneyReceiptTableRow = ({ account, serial, paginationSkip }: IProps) => {
	const [open, setOpen] = useState(false);
	const handleClose = () => setOpen(false);
	const {
		mutate: deleteMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/exhibitor/money-receipt/${account.id}`,
		invalidateQueries: ["money-receipt"],
	});
	return (
		<>
			<TableRow hover>
				<TableCell>{serial + Number(paginationSkip)}</TableCell>
				<TableCell>
					<Typography variant='body1' color='text.primary' noWrap>
						{dayjs(account.payment_date).format("DD-MM-YYYY")}
					</Typography>
				</TableCell>
				<TableCell>{account.money_receipt_no}</TableCell>
				<TableCell>{account.payment_method || "N/A"}</TableCell>
				<TableCell>
					{parseFloat(account?.paid_amount)?.toFixed(2) || 0}
				</TableCell>

				<TableActions
					showView
					viewLink={`/exhibitor/money-receipt/details/${account.id}`}
					showDelete
					handleDeleteFun={() => deleteMoneyReceipt()}
				/>
			</TableRow>

			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Update Money Receipt" }}
			>
				<>
					<EditMoneyReceipt
						id={account.id}
						handleClose={handleClose}
					/>
				</>
			</ModalsWrapper>
		</>
	);
};

export default MoneyReceiptTableRow;
